import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SnlComponentsModule } from 'snl-complib';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './auth/_guards/auth.guard';
import { DatePipe } from '@angular/common';
import { AuthInterceptor } from './shared/services/auth.interceptor';

import { HeaderComponent } from './shared/components/header/header.component';
import { SharedModuleModule } from '../app/shared/shared-module.module';
import { SidebarComponent } from '../app/shared/components/sidebar/sidebar.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ErrorModalComponent } from './auth/error-modal/error-modal.component';
import { CorporateSafetyComponent } from './pages/corporate-safety/corporate-safety.component';
import { TabContentComponent } from './pages/corporate-safety/tab-content/tab-content.component';
import { AcknowledgementComponent } from './acknowledgement/acknowledgement.component';
import { AppConfig } from './app.config';
import { SentryLoggingInterceptor } from './shared/services/sentry-logging.interceptor';
import { LoginRedirectGuard } from './auth/_guards/login-redirect.guard';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';

export function initializeAppConfig(appConfig: AppConfig) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    PrivacyPolicyComponent,
    TabContentComponent,
    ErrorModalComponent,
    CorporateSafetyComponent,
    AcknowledgementComponent,
    AccessDeniedComponent
  ],
  imports: [
    BrowserModule,
    SharedModuleModule,
    IonicModule.forRoot(), 
    AppRoutingModule,
    SnlComponentsModule,
    PinchZoomComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true, // Allow multiple interceptors
    },
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppConfig,
      deps: [AppConfig],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SentryLoggingInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    AuthGuard,
    LoginRedirectGuard,
    DatePipe, 
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

